import * as MapActionTypes from 'actiontypes/map';

export { default as beginGateEvent } from './beginGateEvent';
export { default as changeLocation } from './changeLocation';
export { default as chooseGateEventBranch } from './chooseGateEventBranch';
export { default as fetch } from './fetch';
export { default as goBackFromGateEvent } from './goBackFromGateEvent';
export { default as hideMap } from './hideMap';
export { default as setCurrentArea } from './setCurrentArea';
export { default as setCurrentSetting } from './setCurrentSetting';
export { default as setFallbackMapPreferred } from './setFallbackMapPreferred';

/** ----------------------------------------------------------------------------
 * TOGGLE MAP VIEW
 -----------------------------------------------------------------------------*/

export const showMap = () => ({ type: MapActionTypes.SHOW_MAP });

export const toggleMapView = () => ({
  type: MapActionTypes.TOGGLE_MAP_VIEW,
});

export const setMapShouldUpdate = (shouldUpdate: boolean) => ({
  type: MapActionTypes.SET_MAP_SHOULD_UPDATE,
  payload: { shouldUpdate },
});

export const setCanTravel = (canTravel: boolean) => ({
  type: MapActionTypes.SET_CAN_TRAVEL,
  payload: { canTravel },
});
